import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';

export const defaultLanguage = 'en';

const languageDetectorOptions = {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
  lookupLocalStorage: 'i18nextLng',
};

const savedLanguage = (typeof window !== 'undefined' && localStorage.getItem('i18nextLng')) || defaultLanguage;

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: defaultLanguage,
    resources: {
      en: {
        translation: en,
      },
    },
    detection: languageDetectorOptions,
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    defaultNS: 'translation',
    ns: ['translation'],
    react: {
      useSuspense: false,
    },
    load: 'languageOnly',
    preload: [defaultLanguage],

  });

const updateHtmlLang = (language: string) => document.documentElement.setAttribute('lang', language);

updateHtmlLang(i18next.resolvedLanguage ?? i18next.language);

i18next.on('languageChanged', updateHtmlLang);

export default i18next;
